import axiosInstance from './AxiosInstance';
import { getApiUrl } from '../utils/ApiUtils';

export async function fetchLoginEvents(userId, { limit = 50, offset = 0 } = {}) {
    const url = getApiUrl(`users/${userId}/login-events`);
    const response = await axiosInstance.get(url, { params: { limit, offset } });
    return response.data.events || [];
}
